import {
  type ComponentPropsWithRef,
  type ElementRef,
  type ReactNode,
  forwardRef
} from 'react'

import { Button } from '../Button'

type Props = Omit<ComponentPropsWithRef<typeof Button>, 'children' | 'icon'> & {
  /** 先頭に表示するアイコン */
  icon: ReactNode
  /** ボタンラベル */
  label: ReactNode
}

/**
 * アイコン + テキストラベルの汎用ボタン。
 *
 * 既存 `Button`（antd ラッパ）を土台に「アイコン + ラベル」の合成を標準化した、
 * ドメイン非依存のプレゼンテーション部品。CSV 用途は `CsvActionButton` が本部品をラップする。
 */
export const IconTextButton = forwardRef<ElementRef<typeof Button>, Props>(
  ({ icon, label, ...props }, ref) => (
    <Button ref={ref} icon={icon} {...props}>
      {label}
    </Button>
  )
)
IconTextButton.displayName = 'IconTextButton'
